// Which Analytics tab's view-only lens shared reads carry (owner, 2026-10-01 —
// docs/decisions.md D-258).
//
// An Analytics seat names one company and counts ONLY on its own tab. The tab's
// own endpoints (`/analytics/*`, `/reports*`) get their lens from the server,
// by route. Everything else the tab reads — an invoice opened from the
// Dashboard, a report's source pages — is a SHARED endpoint, so the request has
// to say which tab it comes from. `AnalyticsScreen` sets the lens for the tab on
// screen and clears it on leaving; the HTTP client sends it as
// `ANALYTICS_LENS_HEADER` on every read while it is set, and the mock scopes
// the same reads by it.
//
// The server is the boundary: it honours the header only for a tab the caller
// holds a seat for, only on a read, and only as a narrowing to that tab's
// companies. This module only says which tab the person is looking at.

import type { AnalyticsSection } from './types'

let lens: AnalyticsSection | null = null

export function setAnalyticsLens(section: AnalyticsSection | null): void {
  lens = section
}

export function currentAnalyticsLens(): AnalyticsSection | null {
  return lens
}

/**
 * The reads that never carry it: the shell's own, which answer for the whole
 * app rather than for the tab on screen (the signed-in profile, the pipeline
 * counts in the sidebar). Under a lens they would come back scoped to one
 * company.
 */
const SHELL_PATHS = ['/me', '/queues']

/** Should a request to `path` with `method` carry the lens? */
export function lensApplies(method: string, path: string): boolean {
  if (lens === null || method !== 'GET') return false
  return !SHELL_PATHS.some((p) => path === p || path.startsWith(`${p}/`) || path.startsWith(`${p}?`))
}
